<!--
Author: TangChen
Date: 2018-11-22
Desc: 修改用户信息组件
 -->
<template>
    <div class="comp-user-info comp">
        <el-row class="acct-box">
            <el-form
                ref="acctInfo"
                :model="acctInfo"
                :rules="rules"
                :label-width="(fn ? '160' : '160') + 'px'"
                class="acct-form"
                :class="{ 'certexpdate-box': fn }"
                v-on:submit.native.prevent
            >
                <el-col :span="24">
                    <el-form-item label="姓名：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.custname }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件类型：">
                        <div v-if="!$util.isEmpty(acctInfo.certificatetype)" class="text-con">
                            {{ $cache.getDict("130007", acctInfo.certificatetype) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn" :span="12">
                    <el-form-item label="证件号码：">
                        <div class="text-con">
                            {{ acctInfo.certificateno }}&emsp;
                            <el-button
                                v-if="ocrOnOff"
                                :disabled="ocrStatus"
                                type="warning"
                                size="mini"
                                v-on:click="gotoUpdOcr"
                            >
                                {{ ocrBtnInfo }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="fn" :span="24">
                    <el-form-item
                        :label="$cache.getDict('130007', acctInfo.certificatetype) + '：'"
                    >
                        <div class="text-con">
                            {{ acctInfo.certificateno }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !isBirthdate)" :span="12">
                    <el-form-item
                        label="出生日期："
                        prop="birthday"
                        :class="{ required: !acctInfo.birthday }"
                    >
                        <date-picker
                            v-if="!isBirthdate"
                            :date="birthSet"
                            v-on:date-get="dateBirth"
                        />
                        <div v-if="isBirthdate" class="text-con">
                            {{ $util.fmtDate(acctInfo.birthday) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!isMobile && !fn" :span="12">
                    <el-form-item label="手机号码：" prop="mobileno">
                        <div class="text-con">
                            {{
                                acctInfo.mobileno.length === 11
                                    ? acctInfo.mobileno
                                    : "没有绑定手机号"
                            }}
                            <el-button
                                type="warning"
                                size="mini"
                                v-on:click.prevent="
                                    $router.push({
                                        name: $util.isEmpty(acctInfo.mobileno)
                                            ? 'bindmobile'
                                            : 'checkmobile'
                                    })
                                "
                            >
                                {{ !$util.isEmpty(acctInfo.mobileno) ? "修改" : "绑定" }}
                            </el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-else-if="!fn" :span="12">
                    <el-form-item label="手机号码：" class="required">
                        <div class="text-con">
                            {{ acctInfo.mobileno }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().nationality.trim())" :span="12">
                    <el-form-item label="国籍：" prop="nationality" class="required">
                        <el-select
                            v-model.trim="acctInfo.nationality"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择国籍' : ''"
                        >
                            <el-option
                                v-for="item in nationality"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="(!fn && acctInfo.nationality=='CN') || (fn && acctInfo.nationality=='CN' && !$cache.getUser().province.trim())" :span="12">
                    <el-form-item label="省份：" prop="province" class="required">
                        <el-select v-model.trim="acctInfo.province" filterable placeholder="请选择省份">
                            <el-option
                                v-for="item in province"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>-->
                <el-col v-if="!fn || (fn && !isCertexpdate)" :span="12">
                    <el-form-item label="证件有效期：" prop="validdate" class="required">
                        <date-picker :date="dateSet" v-on:date-get="dateInterval" />
                    </el-form-item>
                </el-col>
                <!--现居地址-->
                <el-col
                    v-if="
                        !fn ||
                        (fn &&
                            (!$cache.getUser().livingcountry.trim() ||
                                !$cache.getUser().livingaddress.trim()))
                    "
                    :span="24"
                >
                    <country-city-select
                        ref="livingaddress"
                        v-model="livingAddressObj"
                        :hide-func="!$util.getConfig().hideFunc"
                        required
                        country-layout="user"
                        v-on:input="getAdrss"
                    ></country-city-select>
                </el-col>
                <el-col
                    v-if="
                        !fn ||
                        (fn &&
                            (!$cache.getUser().livingcountry.trim() ||
                                !$cache.getUser().livingaddress.trim()))
                    "
                    :span="24"
                >
                    <el-form-item label="通讯(现居)地址：" prop="livingaddress" class="required">
                        <el-input
                            v-model.trim="acctInfo.livingaddress"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="
                                $util.getConfig().hideFunc
                                    ? '请输入(现居)通讯地址(例如：xx省xx市xx区xx街道xx号)'
                                    : ''
                            "
                            :maxlength="32"
                            :style="fn ? '' : 'width: 87%;'"
                        />
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="!fn || (fn && !$cache.getUser().annualincome.trim())" :span="12">-->
                <!--<el-form-item label="年收入（元）：" prop="annualincome">-->
                <!--<el-input-->
                <!--v-model.trim="acctInfo.annualincome"-->
                <!--placeholder="请输入年收入金额   "-->
                <!--:maxlength="20"-->
                <!--/>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col v-if="!fn || (fn && !$cache.getUser().specialpersonflag.trim())" :span="12">
                    <el-form-item
                        label="特定自然人标识："
                        prop="specialpersonflag"
                        class="required"
                    >
                        <el-select
                            v-model.trim="acctInfo.specialpersonflag"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择特定自然人标识' : ''"
                        >
                            <el-option
                                v-for="item in specialpersonflag"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="!fn || (fn && !$cache.getUser().isdigniaryorceo.trim())" :span="12">-->
                <!--<el-form-item label="受益人类型：" prop="isdigniaryorceo" class="required">-->
                <!--<el-select v-model.trim="acctInfo.isdigniaryorceo" filterable placeholder="请选择受益人类型">-->
                <!--<el-option-->
                <!--v-for="item in isdigniaryorceo"-->
                <!--:key="item.subitem"-->
                <!--:label="item.subitemname"-->
                <!--:value="item.subitem"-->
                <!--/>-->
                <!--</el-select>-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col
                    v-if="acctInfo.specialpersonflag !== '0' && acctInfo.specialpersonflag !== 'A'"
                    :span="12"
                >
                    <el-form-item
                        label="财产和资金来源："
                        prop="assetssource"
                        :class="
                            acctInfo.specialpersonflag !== '0' && acctInfo.specialpersonflag !== 'A'
                                ? 'required'
                                : ''
                        "
                    >
                        <el-input
                            v-model.trim="acctInfo.assetssource"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入财产和资金来源' : ''"
                            :maxlength="64"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().vocationcode.trim())" :span="12">
                    <el-form-item label="职业：" prop="vocationcode" class="required">
                        <el-select
                            v-model.trim="acctInfo.vocationcode"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择职业' : ''"
                        >
                            <el-option
                                v-for="item in vocationcode"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col v-if="!fn && acctInfo.vocationcode === '06'" :span="12">
                    <el-form-item
                        label="职业补充信息："
                        prop="vocationsupple"
                        :class="{ required: acctInfo.vocationcode === '06' }"
                    >
                        <el-input
                            v-model.trim="acctInfo.vocationsupple"
                            placeholder="请输入职业补充信息"
                            :maxlength="22"
                        />
                    </el-form-item>
                </el-col> -->
                <el-col v-if="!fn || (fn && !$cache.getUser().educationlevel.trim())" :span="12">
                    <el-form-item label="学历：" prop="educationlevel" class="required">
                        <el-select
                            v-model="acctInfo.educationlevel"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择学历' : ''"
                        >
                            <el-option
                                v-for="item in educationlevel"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !isDelivertype)" :span="12">
                    <el-form-item label="对账单寄送周期：" prop="delivertype" class="required">
                        <el-select
                            v-model.trim="acctInfo.delivertype"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择对账单寄送周期' : ''"
                        >
                            <el-option
                                v-for="item in delivertype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !isDelivertype)" :span="12">
                    <el-form-item
                        label="对账单寄送方式："
                        prop="deliverway"
                        :class="acctInfo.delivertype === '1' ? '' : 'required'"
                    >
                        <el-select
                            v-model="acctInfo.deliverway"
                            :placeholder="$util.getConfig().hideFunc ? '请选择对账单寄送方式' : ''"
                            :disabled="!$util.getConfig().hideFunc || acctInfo.delivertype === '1'"
                            multiple
                            maxlength="32"
                            clearable
                        >
                            <el-option
                                v-for="item in deliverways"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="(!fn && acctInfo.certificatetype !== '0') || ocrOnOff" :span="12">
                    <el-form-item class="radio-list" label="性别：" prop="sex">
                        <el-radio-group v-model.trim="acctInfo.sex" :disabled="true">
                            <el-radio v-for="item in sex" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col
                    v-if="!fn || (fn && !isDelivertype && acctInfo.deliverway === '1')"
                    :span="12"
                >
                    <el-form-item
                        label="邮政编码："
                        prop="postcode"
                        :class="{ required: acctInfo.deliverway === '1' }"
                    >
                        <el-input
                            v-model.trim="acctInfo.postcode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入邮政编码' : ''"
                            :maxlength="6"
                        />
                    </el-form-item>
                </el-col>
                <el-col
                    v-if="!fn || (fn && !isDelivertype && acctInfo.deliverway === '3')"
                    :span="12"
                >
                    <el-form-item
                        label="电子邮箱："
                        prop="email"
                        :class="{ required: acctInfo.deliverway === '3' }"
                    >
                        <el-input
                            v-model.trim="acctInfo.email"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入电子邮箱' : ''"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().telno.trim())" :span="24">
                    <el-form-item label="电话号码：" prop="telno">
                        <el-select
                            v-model="acctInfo.telcycode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in telcycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.telcycode == '86'"
                            v-model="acctInfo.telareacode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in telareacode"
                                :key="item.subitem"
                                :label="item.subitem"
                                :value="item.subitem"
                            >
                                <div>
                                    {{ item.subitemname + " " + item.subitem }}
                                </div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.telnoareacodeinput"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                            style="width: 150px !important"
                        />
                        <el-input
                            v-model.trim="acctInfo.telno"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入电话号码' : ''"
                            :maxlength="11"
                            style="width: 300px"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="!fn || (fn && !$cache.getUser().fax.trim())" :span="24">
                    <el-form-item
                        label="传真号码："
                        prop="fax"
                        :class="{ required: acctInfo.deliverway === '2' }"
                    >
                        <el-select
                            v-model="acctInfo.faxcycode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in telcycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.faxcycode == '86'"
                            v-model="acctInfo.faxareacode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in telareacode"
                                :key="item.subitem"
                                :label="item.subitem"
                                :value="item.subitem"
                            >
                                <div>
                                    {{ item.subitemname + " " + item.subitem }}
                                </div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.faxareacodeinput"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                            style="width: 150px !important"
                        />
                        <el-input
                            v-model.trim="acctInfo.fax"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入传真号码' : ''"
                            :maxlength="8"
                            style="width: 300px"
                        />
                    </el-form-item>
                </el-col>

                <!--受益人信息-->
                <el-col style="margin-bottom: 20px">
                    <div class="border"></div>
                </el-col>
                <el-col>
                    <span class="amount">实际受益人</span>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="受益人类型：" class="required">
                        <el-select
                            v-model.trim="acctInfo.benefisself"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择受益人类型' : ''"
                        >
                            <el-option
                                v-for="item in benefisself"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="!fn && acctInfo.benefisself==='0'" :span="12">-->
                <!--<el-form-item label="收入来源：" prop="assetssource" :class="(acctInfo.benefisself==='1')?'required':''">-->
                <!--<el-input v-model.trim="acctInfo.assetssource" placeholder="请输入收入来源" :maxlength="20" />-->
                <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item label="账户实际受益人：" prop="benefitname" class="required">
                        <el-input
                            v-model.trim="acctInfo.benefitname"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入受益人姓名' : ''"
                            :maxlength="20"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item
                        label="受益人证件类型："
                        prop="benefitcertificatetype"
                        class="required"
                    >
                        <el-select
                            v-model.trim="acctInfo.benefitcertificatetype"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择受益人证件类型' : ''"
                        >
                            <el-option
                                v-for="item in benefitcertificatetype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item
                        label="受益人证件号码："
                        prop="benefitcertificateno"
                        class="required"
                    >
                        <el-input
                            v-model.trim="acctInfo.benefitcertificateno"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入受益人证件号码' : ''"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col
                    v-if="(!fn && acctInfo.benefisself === '0') || (fn && !isBeneficiarydateflag)"
                    :span="12"
                >
                    <el-form-item
                        label="受益人证件有效期："
                        prop="benefitvaliddate"
                        class="required"
                    >
                        <date-picker
                            :date="beneficiaryDateSet"
                            v-on:date-get="beneficiaryDateInterval"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item class="radio-list required" label="性别：" prop="benefitsex">
                        <el-radio-group
                            v-model.trim="acctInfo.benefitsex"
                            :disabled="!$util.getConfig().hideFunc"
                        >
                            <el-radio
                                v-for="item in benefitsex"
                                :key="item.subitem"
                                :label="item.subitem"
                            >
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item label="受益人出生日期：" prop="benefitbirthday" class="required">
                        <date-picker
                            :date="beneficiaryBirthSet"
                            v-on:date-get="beneficiaryDateBirth"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item label="受益人职业：" class="required" prop="benefitvocation">
                        <el-select
                            v-model.trim="acctInfo.benefitvocation"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择职业' : ''"
                        >
                            <el-option
                                v-for="item in benefitvocation"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="24">
                    <el-form-item label="受益人电话号码：" class="required" prop="benefittelno">
                        <el-select
                            v-model="acctInfo.benefittelnocycode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in benefittelnocycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.benefittelnocycode == '86'"
                            v-model="acctInfo.benefittelnoareacode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in benefittelnoareacode"
                                :key="item.subitem"
                                :label="item.subitem"
                                :value="item.subitem"
                            >
                                <div>
                                    {{ item.subitemname + " " + item.subitem }}
                                </div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.beneficiarytelnoareacodeinput"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                            style="width: 150px !important"
                        />
                        <el-input
                            v-model.trim="acctInfo.benefittelno"
                            :disabled="!$util.getConfig().hideFunc"
                            style="margin-left: 2px; width: 300px"
                            :placeholder="$util.getConfig().hideFunc ? '请输入电话号码' : ''"
                            :maxlength="8"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="24">
                    <country-city-select
                        ref="benefAddressObj"
                        v-model="benefAddressObj"
                        :hide-func="!$util.getConfig().hideFunc"
                        required
                        country-layout="user"
                        v-on:input="getBenefAdrss"
                    ></country-city-select>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="24">
                    <el-form-item label="通讯(现居)地址：" prop="benefitaddress" class="required">
                        <el-input
                            v-model.trim="acctInfo.benefitaddress"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="
                                $util.getConfig().hideFunc
                                    ? '请输入(现居)通讯地址(例如：xx省xx市xx区xx街道xx号)'
                                    : ''
                            "
                            :maxlength="32"
                            style="width: 87%"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item label="电子邮箱：" prop="benefitemail" class="required">
                        <el-input
                            v-model.trim="acctInfo.benefitemail"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入电子邮箱' : ''"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.benefisself === '0'" :span="12">
                    <el-form-item label="邮政编码：" prop="benefitpostcode" class="required">
                        <el-input
                            v-model.trim="acctInfo.benefitpostcode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入邮政编码' : ''"
                            :maxlength="6"
                        />
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="acctInfo.benefisself==='0'" :span="12">
                    <el-form-item label="受益人与持有人关系：" prop="benefrelation" class="required">
                        <el-input v-model.trim="acctInfo.benefrelation" placeholder="请输入受益人与持有人关系" />
                    </el-form-item>
                </el-col>-->

                <!--控制人信息-->
                <el-col style="padding-bottom: 20px">
                    <div class="border"></div>
                </el-col>
                <el-col>
                    <span class="amount">实际控制人</span>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="控制人类型：" prop="actualisself" class="required">
                        <el-select
                            v-model.trim="acctInfo.actualisself"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择受益人类型' : ''"
                        >
                            <el-option
                                v-for="item in actualisself"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item label="账户实际控制人：" prop="actualctrlname" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrlname"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入控制人姓名' : ''"
                            :maxlength="20"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item
                        label="控制人证件类型："
                        prop="actualctrlcertype"
                        class="required"
                    >
                        <el-select
                            v-model.trim="acctInfo.actualctrlcertype"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择控制人证件类型' : ''"
                        >
                            <el-option
                                v-for="item in actualctrlcertype"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item label="控制人证件号码：" prop="actualctrlcerno" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrlcerno"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入控制人证件号码' : ''"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col
                    v-if="
                        (!fn && acctInfo.actualisself === '0') || (fn && !isactualctrlvalidateflag)
                    "
                    :span="12"
                >
                    <el-form-item
                        label="控制人证件有效期："
                        prop="actualctrlvalidate"
                        class="required"
                    >
                        <date-picker
                            :date="actualctrlDateSet"
                            v-on:date-get="actualctrlDateInterval"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item class="radio-list required" label="性别：" prop="actualctrlsex">
                        <el-radio-group
                            v-model.trim="acctInfo.actualctrlsex"
                            :disabled="!$util.getConfig().hideFunc"
                        >
                            <el-radio
                                v-for="item in actualctrlsex"
                                :key="item.subitem"
                                :label="item.subitem"
                            >
                                {{ item.subitemname }}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item
                        label="控制人出生日期："
                        prop="actualctrlbirthday"
                        class="required"
                    >
                        <date-picker
                            :date="actualctrlBirthSet"
                            v-on:date-get="actualctrlDateBirth"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item label="控制人职业：" class="required" prop="actualctrlvocation">
                        <el-select
                            v-model.trim="acctInfo.actualctrlvocation"
                            :disabled="!$util.getConfig().hideFunc"
                            filterable
                            :placeholder="$util.getConfig().hideFunc ? '请选择职业' : ''"
                        >
                            <el-option
                                v-for="item in actualctrlvocation"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <el-form-item label="控制人电话号码：" class="required" prop="actualctrltelno">
                        <el-select
                            v-model="acctInfo.actelnocycode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择国家码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in telcycode"
                                :key="item.subitem"
                                :label="item.subitemname + ' ' + item.subitem"
                                :value="item.subitem"
                            />
                        </el-select>
                        <el-select
                            v-if="acctInfo.actelnocycode == '86'"
                            v-model="acctInfo.actelnoareacode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请选择地区码' : ''"
                            style="width: 150px !important"
                        >
                            <el-option
                                v-for="item in telareacode"
                                :key="item.subitem"
                                :label="item.subitem"
                                :value="item.subitem"
                            >
                                <div>
                                    {{ item.subitemname + " " + item.subitem }}
                                </div>
                            </el-option>
                        </el-select>
                        <el-input
                            v-else
                            v-model.trim="acctInfo.actualctrltelnoareacodeinput"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入地区码' : ''"
                            style="width: 150px !important"
                        />
                        <el-input
                            v-model.trim="acctInfo.actualctrltelno"
                            :disabled="!$util.getConfig().hideFunc"
                            style="margin-left: 2px; width: 300px"
                            :placeholder="$util.getConfig().hideFunc ? '请输入电话号码' : ''"
                            :maxlength="8"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <country-city-select
                        ref="actualAddressObj"
                        v-model="actualAddressObj"
                        :hide-func="!$util.getConfig().hideFunc"
                        required
                        country-layout="user"
                        v-on:input="getActualAdrss"
                    ></country-city-select>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="24">
                    <el-form-item label="通讯(现居)地址：" prop="actualctrladdr" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrladdr"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="
                                $util.getConfig().hideFunc
                                    ? '请输入(现居)通讯地址(例如：xx省xx市xx区xx街道xx号)'
                                    : ''
                            "
                            :maxlength="32"
                            style="width: 87%"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item label="电子邮箱：" prop="actualctrlemail" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrlemail"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入电子邮箱' : ''"
                            :maxlength="32"
                        />
                    </el-form-item>
                </el-col>
                <el-col v-if="acctInfo.actualisself === '0'" :span="12">
                    <el-form-item label="邮政编码：" prop="actualctrlpostcode" class="required">
                        <el-input
                            v-model.trim="acctInfo.actualctrlpostcode"
                            :disabled="!$util.getConfig().hideFunc"
                            :placeholder="$util.getConfig().hideFunc ? '请输入邮政编码' : ''"
                            :maxlength="6"
                        />
                    </el-form-item>
                </el-col>
                <!--<el-col v-if="acctInfo.actualisself==='0'" :span="12">
                    <el-form-item label="控制人与持有人关系：" prop="actualrelation" class="required">
                        <el-input v-model.trim="acctInfo.actualrelation" placeholder="请输入控制人与持有人关系" />
                    </el-form-item>
                </el-col>-->

                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model.trim="acctInfo.pwd"
                            :disabled="!$util.getConfig().hideFunc"
                            type="password"
                            :placeholder="$util.getConfig().hideFunc ? '请输入交易密码' : ''"
                            :maxlength="16"
                        />
                        <!--                        <span-->
                        <!--                            class="redemp-btn"-->
                        <!--                            v-on:click.prevent="$router.push({ name: 'tradepwd' })"-->
                        <!--                        >-->
                        <!--                            <span class="like-a">忘记密码？</span>-->
                        <!--                        </span>-->
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button
                        v-if="$util.getConfig().hideFunc"
                        type="primary"
                        class="medium"
                        v-on:click.prevent="submitInfo('acctInfo')"
                    >
                        保存
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">返回</el-button>
                </el-col>
            </el-form>
        </el-row>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="50%"
            :close-on-click-modal="false"
        >
            <el-checkbox v-model="checked" class="check-style"></el-checkbox>
            <span>
                本人承诺，以上所填信息发生重大变化时，本人将主动、及时进行信息更新，以便于贵机构重新评估本人风险承受能力。如本人未进行前述更新导致的投资损失以及其他法律后果由本人自行承担。
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="!checked" v-on:click="gotoSub()">
                    确 定
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker.vue";
import countryCitySelect from "@/components/acct/countryCitySelect.vue";
import { httpClient } from "@/assets/js/http";
import urls from "@/api/urls";
import userApi from "@/api/user";
export default {
    name: "UserInfo",
    components: {
        datePicker,
        countryCitySelect
    },
    props: {
        fn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isPwdCheck: false,
            acctInfo: {
                pwd: "",
                telareacode: "",
                telnoareacodeinput: "",
                faxareacodeinput: "",
                benefittelnoareacode: "",
                beneficiarytelnoareacodeinput: "",
                actelnoareacode: "",
                actualctrltelnoareacodeinput: "",
                actualrelation: "",
                benefrelation: ""
            },
            livingAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 数据字典
            certTypes: [],
            delivertype: [],
            sex: [],
            vocationcode: [],
            educationlevel: [],
            deliverways: [],
            nationality: [],
            province: [],
            specialpersonflag: [],
            isdigniaryorceo: [],
            faxareacode: [],
            // 受益人
            benefisself: [],
            benefitcertificatetype: [],
            benefitsex: [],
            benefitvocation: [],
            benefittelnocycode: [],
            benefittelnoareacode: [],
            benefAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 控制人
            actualisself: [],
            actualctrltype: [],
            actualctrlsex: [],
            actualctrlvocation: [],
            telcycode: [],
            telareacode: [],
            actualAddressObj: {
                country: "CN",
                province: null,
                city: null,
                county: null
                //                address:null,
            },
            // 日期配置
            dateSet: {
                type: "3",
                max: "",
                dis: !this.$util.getConfig().hideFunc
            },
            birthSet: {
                type: "1",
                min: "",
                dis: !this.$util.getConfig().hideFunc
            },
            beneficiaryDateSet: {
                type: "3",
                max: "",
                val: "",
                text: "请选择证件有效期",
                dis: !this.$util.getConfig().hideFunc
            },
            beneficiaryBirthSet: {
                type: "1",
                max: "",
                dis: !this.$util.getConfig().hideFunc,
                val: "",
                text: "请选择出生日期"
            },
            actualctrlDateSet: {
                type: "3",
                max: "",
                val: "",
                text: "请选择证件有效期",
                dis: !this.$util.getConfig().hideFunc
            },
            actualctrlBirthSet: {
                type: "1",
                max: "",
                dis: !this.$util.getConfig().hideFunc,
                val: "",
                text: "请选择出生日期"
            },
            beneficChangeFlag: true,
            actualctrlChangeFlag: true,
            isMobile: false, // 是否有手机号码
            isDelivertype: true, // 是否有delivertype的值，仅对fn=true起作用
            isBirthdate: true, // 是否有birthdate的值，仅对fn=true起作用
            isCertexpdate: true, // 是否有certexpdate的值，仅对fn=true起作用
            isBeneficiarydateflag: true,
            isactualctrlvalidateflag: true,
            dialogVisible: false,
            checked: false,
            rules: {
                mobileno: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur"
                    },
                    { validator: this.$util.validateMobile, trigger: "blur" }
                ],
                nationality: [
                    {
                        required: true,
                        message: "请选择国籍",
                        trigger: "change"
                    }
                ],
                /* province: [
                    { required: true, message: "请选择省份", trigger: "change" }
                ], */
                birthday: [
                    {
                        required: true,
                        validator: this.$util.validateDate,
                        trigger: "blur"
                    }
                ],
                validdate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                delivertype: [
                    {
                        required: true,
                        message: "请选对账单寄送周期",
                        trigger: "change"
                    }
                ],
                deliverway: [{ validator: this.validateDeliverway, trigger: "change" }],
                livingaddress: [
                    {
                        required: true,
                        validator: this.validateAddress,
                        trigger: "blur"
                    }
                ],
                postcode: [{ validator: this.validatePostCode, trigger: "blur" }],
                // vocationsupple: [
                //     {
                //         required: true,
                //         validator: this.validateVocationsupple,
                //         trigger: "blur",
                //     },
                // ],
                educationlevel: [
                    {
                        required: true,
                        message: "请选择学历",
                        trigger: "change"
                    }
                ],
                vocationcode: [
                    {
                        required: true,
                        message: "请选择职业",
                        trigger: "change"
                    }
                ],
                email: [{ validator: this.validateEmail, trigger: "blur" }],
                telno: [{ validator: this.$util.validateFaxNum, trigger: "blur" }],
                fax: [{ validator: this.validateFax, trigger: "blur" }],
                faxareacode: [
                    {
                        required: true,
                        message: "请选择地区码",
                        trigger: "change"
                    }
                ],
                benefisself: [
                    {
                        required: true,
                        message: "请选择受益人类型",
                        trigger: "change"
                    }
                ],
                benefitname: [{ validator: this.validateBeneficiary, trigger: "blur" }],
                benefitcertificatetype: [
                    {
                        validator: this.validateBeneficiarytype,
                        trigger: "change"
                    }
                ],
                benefitcertificateno: [{ validator: this.validateBeneficiaryno, trigger: "blur" }],
                benefitbirthday: [
                    {
                        required: true,
                        validator: this.$util.validateDate,
                        trigger: "blur"
                    }
                ],
                benefitvaliddate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                benefitsex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                benefitvocation: [
                    {
                        required: true,
                        message: "请选择职业",
                        trigger: "change"
                    }
                ],
                benefitemail: [{ validator: this.$util.validateEmail, trigger: "blur" }],
                benefitpostcode: [{ validator: this.$util.validatePostCode, trigger: "blur" }],
                benefitaddress: [
                    {
                        required: true,
                        validator: this.validateAddress,
                        trigger: "blur"
                    }
                ],
                actualisself: [
                    {
                        required: true,
                        message: "请选择控制人类型",
                        trigger: "change"
                    }
                ],
                actualctrlname: [{ validator: this.validateActualctrlname, trigger: "blur" }],
                actualctrlsex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                actualctrlcertype: [
                    {
                        validator: this.validateActualctrlidtype,
                        trigger: "change"
                    }
                ],
                actualctrlcerno: [{ validator: this.validateActualctrl, trigger: "blur" }],
                actualctrlbirthday: [
                    {
                        required: true,
                        validator: this.$util.validateDate,
                        trigger: "blur"
                    }
                ],
                actualctrlvalidate: [
                    { validator: this.validateMin, trigger: "blur" },
                    { validator: this.$util.validateDate, trigger: "blur" }
                ],
                actualctrlvocation: [
                    {
                        required: true,
                        message: "请选择职业",
                        trigger: "change"
                    }
                ],
                actualctrlpostcode: [{ validator: this.validatePostCode2, trigger: "blur" }],
                actualctrlemail: [{ validator: this.validateEmail, trigger: "blur" }],
                assetssource: [{ validator: this.validateAssetssource, trigger: "blur" }],
                /* actualrelation: [
                    { required: true, message: "请输入控制人与持有人关系", trigger: "blur" }
                ], */
                benefittelno: [{ validator: this.$util.validateFaxNum, trigger: "blur" }],
                actualctrltelno: [{ validator: this.$util.validateFaxNum, trigger: "blur" }],
                actualctrladdr: [
                    {
                        required: true,
                        validator: this.validateAddress,
                        trigger: "blur"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ],
                //                annualincome: [
                //                    { required: true, message: "请输入年收入", trigger: "blur" }
                //                ],
                specialpersonflag: [
                    {
                        required: true,
                        message: "请选择特定自然人标识",
                        trigger: "change"
                    }
                ],
                isdigniaryorceo: [
                    {
                        required: true,
                        message: "请选择受益人类型",
                        trigger: "change"
                    }
                ]
                /* benefrelation: [
                    { required: true, message: "请输入受益人与持有人关系", trigger: "blur" }
                ] */
            },
            ocrOnOff: false,
            hasOcr: "0",
            ocrStatus: false,
            ocrBtnInfo: "更新证件信息",
            ocrUploadFlag: ""
        };
    },
    watch: {
        "acctInfo.delivertype"(val) {
            if (val === "1") {
                this.acctInfo.deliverway = "";
            }
        },
        // "acctInfo.vocationcode"(val) {
        //     if (val !== "06") {
        //         this.acctInfo.vocationsupple = "";
        //     }
        // },
        "acctInfo.benefisself"(val) {
            if (this.beneficChangeFlag) {
                this.beneficChangeFlag = !this.beneficChangeFlag;
                return false;
            }
            this.acctInfo.benefitname = "";
            this.acctInfo.benefitcertificatetype = "";
            this.acctInfo.benefitcertificateno = "";
            this.acctInfo.benefitvaliddate = "";
            this.acctInfo.benefitsex = "";
            this.acctInfo.benefitbirthday = "";
            this.acctInfo.benefitvocation = "";
            this.acctInfo.benefittelnocycode = "";
            this.acctInfo.benefittelnoareacode = "";
            this.acctInfo.beneficiarytelnoareacodeinput = "";
            this.acctInfo.benefittelno = "";
            this.acctInfo.benefitcountry = "";
            this.acctInfo.benefitaddressprovince = "";
            this.acctInfo.benefitaddresscity = "";
            this.acctInfo.benefitaddresscounty = "";
            this.acctInfo.benefitaddress = "";
            this.acctInfo.benefitemail = "";
            this.acctInfo.benefitpostcode = "";
            this.acctInfo.benefrelation = "";
            this.$set(this.beneficiaryDateSet, "val", "");
            this.$set(this.beneficiaryBirthSet, "val", "");
            this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
            this.$set(this.beneficiaryBirthSet, "time", new Date().getTime());
        },
        "acctInfo.actualisself"(val) {
            if (this.actualctrlChangeFlag) {
                this.actualctrlChangeFlag = !this.actualctrlChangeFlag;
                return false;
            }
            this.acctInfo.actualctrl = "";
            this.acctInfo.actualctrlname = "";
            this.acctInfo.actualctrltype = "";
            this.acctInfo.actualctrlno = "";
            this.acctInfo.actualctrldate = "";
            this.acctInfo.actualctrlsex = "";
            this.acctInfo.actualctrlbirthday = "";
            this.acctInfo.actualctrlvocation = "";
            this.acctInfo.actelnocycode = "";
            this.acctInfo.actelnoareacode = "";
            this.acctInfo.actualctrltelnoareacodeinput = "";
            this.acctInfo.actualctrltelno = "";
            this.acctInfo.actualctrlcountry = "";
            this.acctInfo.actualctrladdrprovince = "";
            this.acctInfo.actualctrladdrcity = "";
            this.acctInfo.actualctrladdrcounty = "";
            this.acctInfo.actualctrladdr = "";
            this.acctInfo.actualctrlemail = "";
            this.acctInfo.actualctrlpostcode = "";
            this.acctInfo.actualrelation = "";
            this.acctInfo.actualctrlvalidate = "";
            this.acctInfo.actualctrlcerno = "";
            this.acctInfo.actualctrlcertype = "";
            this.$set(this.actualctrlDateSet, "val", "");
            this.$set(this.actualctrlBirthSet, "val", "");
            this.$set(this.actualctrlDateSet, "time", new Date().getTime());
            this.$set(this.actualctrlBirthSet, "time", new Date().getTime());
        },
        "acctInfo.telcycode"(val) {
            if (val != "86") {
                this.acctInfo.telnoareacodeinput = this.acctInfo.telareacode;
            }
        },
        "acctInfo.telnoareacodeinput"(val) {
            this.acctInfo.telareacode = this.acctInfo.telnoareacodeinput;
        },
        "acctInfo.faxcycode"(val) {
            if (val != "86") {
                this.acctInfo.faxareacodeinput = this.acctInfo.faxareacode;
            }
        },
        "acctInfo.faxareacodeinput"(val) {
            this.acctInfo.faxareacode = this.acctInfo.faxareacodeinput;
        },
        "acctInfo.benefittelnocycode"(val) {
            if (val != "86") {
                this.acctInfo.beneficiarytelnoareacodeinput = this.acctInfo.benefittelnoareacode;
            }
        },
        "acctInfo.beneficiarytelnoareacodeinput"(val) {
            this.acctInfo.benefittelnoareacode = this.acctInfo.beneficiarytelnoareacodeinput;
        },
        "acctInfo.actelnocycode"(val) {
            if (val != "86") {
                this.acctInfo.actualctrltelnoareacodeinput = this.acctInfo.actelnoareacode;
            }
        },
        "acctInfo.actualctrltelnoareacodeinput"(val) {
            this.acctInfo.actelnoareacode = this.acctInfo.actualctrltelnoareacodeinput;
        }
    },
    created() {
        const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
        // this.hasOcr = this.$cache.getParams("hasocr");
        this.birthSet.max = this.$util.fmtDate(birthmax);
        this.birthSet.min = this.$util.fmtDate("19000101");
        // 重新提取最小日期
        const conf = this.$util.getConfig().const;
        const info = this.$cache.getUser();
        this.beneficiaryDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.beneficiaryBirthSet.max = this.$util.fmtDate(birthmax);
        this.beneficiaryBirthSet.min = this.$util.fmtDate("19000101");
        this.$set(this.beneficiaryDateSet, "val", format(info.benefitvaliddate, "YYYY-MM-DD"));
        this.$set(this.beneficiaryDateSet, "time", new Date().getTime());
        this.$set(this.beneficiaryBirthSet, "val", format(info.benefitbirthday, "YYYY-MM-DD"));
        this.$set(this.beneficiaryBirthSet, "time", new Date().getTime());
        this.actualctrlDateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.actualctrlBirthSet.max = this.$util.fmtDate(birthmax);
        this.actualctrlBirthSet.min = this.$util.fmtDate(conf.BIRTH_DATE);
        this.$set(this.actualctrlDateSet, "val", format(info.actualctrlvalidate, "YYYY-MM-DD"));
        this.$set(this.actualctrlDateSet, "time", new Date().getTime());
        this.$set(this.actualctrlBirthSet, "val", format(info.actualctrlbirthday, "YYYY-MM-DD"));
        this.$set(this.actualctrlBirthSet, "time", new Date().getTime());
        // 修改用户信息接口不支持校验交易密码
        // this.isPwdCheck = this.$cache.getPwdCheck("B1");
        const _x = {};
        for (let item in info) {
            _x[item] = info[item] ? (info[item] + "").trim() : "";
        }
        if (!_x.delivertype) {
            this.isDelivertype = false;
        }
        if (!_x.birthday) {
            this.isBirthdate = false;
        }
        if (!_x.validdate || _x.certexpired === "1") {
            this.isCertexpdate = false;
        }
        if (_x.benefexpdate === "1") {
            this.isBeneficiarydateflag = false;
        }
        if (_x.actualctrlexp === "1") {
            this.isactualctrlvalidateflag = false;
        }
        if (_x.mobileno) {
            this.isMobile = true;
        }
        // 国籍默认中国
        if (!_x.nationality) {
            _x.nationality = "CN";
        }
        if (this.$route.query) {
            _x.custname = this.$route.query.custname || _x.custname;
            _x.certificateno = this.$route.query.certificateno || _x.certificateno;
            _x.validdate = this.$route.query.vailddate || _x.validdate;
            _x.birthday = this.$route.query.birthdate || _x.birthday;
            if (_x.certTypeText === "身份证" && this.$route.query.certificateno) {
                _x.sex = (this.$route.query.certificateno.substr(16, 1) % 2).toString();
            }
            if (
                _x.benefitcertificatetype === "身份证" &&
                this.$route.query.beneficiaryno &&
                _x.benefisself === "1"
            ) {
                _x.benefitsex = (this.$route.query.beneficiaryno.substr(16, 1) % 2).toString();
            }
            if (
                _x.benefitcertificatetype === "身份证" &&
                this.$route.query.actualctrlidcode &&
                _x.actualisself === "1"
            ) {
                _x.actualctrlsex = (
                    this.$route.query.actualctrlidcode.substr(16, 1) % 2
                ).toString();
            }
            const _this = this;
            if (this.$route.query.birthdate) {
                const _date = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
                if (
                    Number(this.$route.query.birthdate) >= Number(_date) &&
                    this.$cache.getCompanyInfoParam("100047") == "0"
                ) {
                    _this
                        .$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "", {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: (action) => {
                                _this.$router.push({ name: "info" });
                            }
                        })
                        .then(() => {
                            return false;
                        })
                        .catch(() => {
                            return false;
                        });
                }
            }
        }
        _x.deliverway = _x.deliverway && _x.deliverway.split(",");
        this.acctInfo = Object.assign({}, this.acctInfo, _x);
        this.mobileBind(this.acctInfo);
        this.dateSet.val = this.acctInfo.validdate
            ? this.$util.fmtDate(this.acctInfo.validdate)
            : "";
        if (this.acctInfo.validtype == "1") {
            this.dateSet.val = "9999-12-31";
        }
        this.dateSet.max = this.$util.fmtDate(conf.CARD_DATE_MAX);
        this.birthSet.min = this.$util.fmtDate(conf.BIRTH_DATE);
        // :TODO: 测试瑞年
        this.birthSet.max = this.$util.fmtDate(format(new Date(), "YYYYMMDD") - 180000);

        this.certTypes = this.$cache.getDict("130007");
        this.delivertype = this.$cache.getDict("110046");
        this.sex = this.$cache.getDict("110059").reverse();
        this.benefitsex = this.$cache.getDict("110059").reverse();
        this.actualctrlsex = this.$cache.getDict("110059").reverse();
        this.vocationcode = this.$cache.getDict("150141");
        this.deliverways = this.$cache.getDict("100013");
        this.educationlevel = this.$cache.getDict("20011");
        this.specialpersonflag = this.$cache.getDict("120200"); // 特定自然人标识
        this.isdigniaryorceo = this.$cache.getDict("120200");
        this.nationality = this.$util.changeArrIndex(this.$cache.getDict("120109"), "CN");
        this.province = this.$cache.getDict("120122");
        // 受益人
        this.benefitvocation = this.$cache.getDict("150141");
        // this.benefittelnocycode = this.$cache.getDict("150136"); //国家码
        this.benefittelnocycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.benefittelnoareacode = this.$cache.getDict("150137");
        // 控制人
        this.actualctrlvocation = this.$cache.getDict("150141");
        // this.telcycode = this.$cache.getDict("150136"); //国家码
        this.telcycode = this.$util.changeArrIndex(this.$cache.getDict("150136"), "86");
        this.telareacode = this.$cache.getDict("150137");
        this.benefisself = this.$cache.getDict("120137");
        this.benefitcertificatetype = this.$cache.getDict("130007");
        this.actualisself = this.$cache.getDict("120137");
        this.actualctrlcertype = this.$cache.getDict("130007");
        // this.getOcrOpenStatus();
        this.initAddress();
        this.initBenefAddress();
        this.initActualAddress();
    },
    methods: {
        initAddress() {
            this.livingAddressObj["country"] = this.acctInfo["livingcountry"];
            this.livingAddressObj["province"] = this.acctInfo["livingaddressprovince"];
            this.livingAddressObj["city"] = this.acctInfo["livingaddresscity"];
            this.livingAddressObj["county"] = this.acctInfo["livingaddresscounty"];
        },
        getAdrss(data) {
            this.acctInfo.address = data.address;
            this.acctInfo.livingaddress = data.address;
            if (data.country !== "CN") {
                this.livingAddressObj["province"] = "";
                this.livingAddressObj["city"] = "";
                this.livingAddressObj["county"] = "";
            }
        },
        // 受益人国家、省、市、县
        initBenefAddress() {
            this.benefAddressObj["country"] = this.acctInfo["benefitcountry"];
            this.benefAddressObj["province"] = this.acctInfo["benefitaddressprovince"];
            this.benefAddressObj["city"] = this.acctInfo["benefitaddresscity"];
            this.benefAddressObj["county"] = this.acctInfo["benefitaddresscounty"];
        },
        getBenefAdrss(data) {
            this.acctInfo.benefitaddress = data.address;
            if (data.country !== "CN") {
                this.benefAddressObj["province"] = "";
                this.benefAddressObj["city"] = "";
                this.benefAddressObj["county"] = "";
            }
        },
        // 控制人国家、省、市、县
        initActualAddress() {
            this.actualAddressObj["country"] = this.acctInfo["actualctrlcountry"];
            this.actualAddressObj["province"] = this.acctInfo["actualctrladdrprovince"];
            this.actualAddressObj["city"] = this.acctInfo["actualctrladdrcity"];
            this.actualAddressObj["county"] = this.acctInfo["actualctrladdrcounty"];
        },
        setAddress() {
            this.acctInfo["livingcountry"] = this.livingAddressObj["country"];
            this.acctInfo["livingaddressprovince"] = this.livingAddressObj["province"];
            this.acctInfo["livingaddresscity"] = this.livingAddressObj["city"];
            this.acctInfo["livingaddresscounty"] = this.livingAddressObj["county"];

            this.acctInfo["benefitcountry"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["country"] : "";
            this.acctInfo["benefitaddressprovince"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["province"] : "";
            this.acctInfo["benefitaddresscity"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["city"] : "";
            this.acctInfo["benefitaddresscounty"] =
                this.acctInfo["benefisself"] == "0" ? this.benefAddressObj["county"] : "";

            this.acctInfo["actualctrlcountry"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["country"] : "";
            this.acctInfo["actualctrladdrprovince"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["province"] : "";
            this.acctInfo["actualctrladdrcity"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["city"] : "";
            this.acctInfo["actualctrladdrcounty"] =
                this.acctInfo["actualisself"] == "0" ? this.actualAddressObj["county"] : "";
        },
        getActualAdrss(data) {
            this.acctInfo.actualctrladdr = data.address;
            if (data.country !== "CN") {
                this.actualAddressObj["province"] = "";
                this.actualAddressObj["city"] = "";
                this.actualAddressObj["county"] = "";
            }
        },
        checkAddressInfo() {
            let hasLivingAddrInfo = true;
            if (this.acctInfo.livingcountry === this.$const.CN) {
                hasLivingAddrInfo =
                    !!this.acctInfo.livingaddressprovince &&
                    !!this.acctInfo.livingaddress &&
                    !!this.acctInfo.livingaddresscity;
            } else {
                hasLivingAddrInfo = !!this.acctInfo.livingaddress;
            }
            if (!hasLivingAddrInfo) {
                this.$alert("请完善现居地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        checkBenefActualInfo() {
            let hasBenefInfo = true;
            let hasCtrlInfo = true;
            if (this.acctInfo.benefisself === "0") {
                let excludeitems = ["county"]; // 有些地方没有县
                if (this.acctInfo.benefitcountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                }
                this.benefAddressObj.address = this.acctInfo.benefitaddress;
                hasBenefInfo = this.$util.checkInfoFilled(this.benefAddressObj, excludeitems);
            }
            if (this.acctInfo.actualisself === "0") {
                let excludeitems = ["county", "actualAddressObj"]; // 有些地方没有县
                if (this.acctInfo.actualctrlcountry !== this.$const.CN) {
                    excludeitems = excludeitems.concat(["province", "city", "county"]);
                }
                this.actualAddressObj.address = this.acctInfo.actualctrladdr;
                hasCtrlInfo = this.$util.checkInfoFilled(this.actualAddressObj, excludeitems);
            }

            if (!hasCtrlInfo) {
                this.$alert("请完善实际控制人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            if (!hasBenefInfo) {
                this.$alert("请完善实际受益人地址(国家/地区-省-市-县)信息！", "提示");
                return false;
            }
            return true;
        },
        mobileBind(info) {
            if (info.mobileno.length != 11 && info.needfillcustinfo == "0") {
                this.$alert("您暂未绑定手机号，请前往绑定！", "手机号绑定", {
                    confirmButttonText: "前往",
                    showCancelButton: false,
                    type: "warning",
                    callback: (action) => {
                        this.$router.push({ name: "bindmobile" });
                    }
                }).then((res) => {});
            }
        },
        dateInterval(val) {
            this.acctInfo.validdate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("validdate");
        },
        dateBirth(val) {
            this.acctInfo.birthday = val !== null ? val.replace(/-/g, "") : "";
        },
        // 受益人出生日期
        beneficiaryDateBirth(val) {
            this.acctInfo.benefitbirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        // 受益人证件有效期
        beneficiaryDateInterval(val) {
            this.acctInfo.benefitvaliddate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("benefitvaliddate");
        },
        // 控制人出生日期
        actualctrlDateBirth(val) {
            this.acctInfo.actualctrlbirthday = val !== null ? val.replace(/-/g, "") : "";
        },
        // 控制人证件有效期
        actualctrlDateInterval(val) {
            this.acctInfo.actualctrlvalidate = val !== null ? val.replace(/-/g, "") : "";
            this.$refs.acctInfo.validateField("actualctrlvalidate");
        },
        validateAddress(rule, value, callback) {
            /* if (this.acctInfo.deliverway === "1" && !value) { */
            if (!value) {
                callback(new Error("请输入联系地址"));
            } else {
                callback();
            }
        },
        validateLocation(rule, value, callback) {
            if (this.acctInfo.nationality === "CN") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择省份"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateAssetssource(rule, value, callback) {
            if (
                this.acctInfo.specialpersonflag === "1" ||
                this.acctInfo.specialpersonflag === "2" ||
                this.acctInfo.specialpersonflag === "3" ||
                this.acctInfo.specialpersonflag === "4"
            ) {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入收入来源"));
                }
            }
            if (!this.$util.isEmpty(value)) {
                this.$util.validateGeneral(rule, value, callback, "收入来源");
            } else {
                callback();
            }
        },
        validateBeneficiary(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiarytype(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateBeneficiaryno(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入受益人证件号码"));
                } else {
                    this.$util.validateCertNo(
                        rule,
                        value,
                        callback,
                        this.acctInfo.benefitcertificatetype
                    );
                }
            } else {
                callback();
            }
        },
        validateBeneficiarydate(rule, value, callback) {
            if (this.acctInfo.benefisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择受益人证件有效期"));
                } else {
                    if (Number(value) < Number(format(new Date(), "YYYYMMDD"))) {
                        callback(new Error("受益人有效期必须大于当前日期，请重新选择"));
                    } else {
                        callback();
                    }
                }
            } else {
                callback();
            }
        },
        validateActualctrlname(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人姓名"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrlidtype(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请选择控制人证件类型"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        validateActualctrl(rule, value, callback) {
            if (this.acctInfo.actualisself === "0") {
                if (this.$util.isEmpty(value)) {
                    callback(new Error("请输入控制人证件号码"));
                } else {
                    this.$util.validateCertNo(
                        rule,
                        value,
                        callback,
                        this.acctInfo.actualctrlcertype
                    );
                }
            } else {
                callback();
            }
        },
        validatePostCode(rule, value, callback) {
            if (this.acctInfo.deliverway === "1" || value !== "") {
                this.$util.validatePostCode(rule, value, callback);
            } else {
                callback();
            }
        },
        validatePostCode2(rule, value, callback) {
            this.$util.validatePostCode(rule, value, callback);
        },
        // validateVocationsupple(rule, value, callback) {
        //     if (this.acctInfo.vocationcode === "06" && !value) {
        //         callback(new Error("请输入职业补充信息"));
        //     } else {
        //         callback();
        //     }
        // },
        validateDeliverway(rule, value, callback) {
            if (
                !this.$util.isEmpty(this.acctInfo.delivertype) &&
                this.acctInfo.delivertype !== "1" &&
                this.$util.isEmpty(value)
            ) {
                callback(new Error("请选择对账单寄送方式"));
            } else {
                callback();
            }
        },
        validateFax(rule, value, callback) {
            if (this.acctInfo.deliverway === "2") {
                this.$util.validateFaxNum(rule, value, callback);
            } else {
                callback();
            }
        },
        validateEmail(rule, value, callback) {
            if (this.acctInfo.deliverway === "3" || value !== "") {
                this.$util.validateEmail(rule, value, callback);
            } else {
                callback();
            }
        },
        async gotoSub() {
            const _this = this;
            _this.dialogVisible = false;
            if (this.acctInfo.birthday) {
                const _date = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
                if (Number(this.acctInfo.birthday) >= Number(_date)) {
                    _this
                        .$alert("根据您的证件信息，您属于未成年人，暂时无法开户！", "", {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: (action) => {
                                _this.$router.push({ name: "info" });
                            }
                        })
                        .then(() => {
                            return false;
                        })
                        .catch(() => {
                            return false;
                        });
                    return;
                }
            }
            let _obj = Object.assign({}, _this.acctInfo);
            // let _obj = _this.$util.getObjParam(
            //     _this.acctInfo,
            //     "validdate,specialpersonflag,nationality,vocationcode,delivertype,deliverway,sex,educationlevel,postcode,email,telno,telareacode,telcycode,fax,faxcycode,faxareacode,address,livingaddress,remark,birthday,pwd,benefisself,livingaddressprovince,livingaddresscity,livingaddresscounty,assetssource,benefitname,benefitcertificatetype,benefitcertificateno,benefitvaliddate,benefitsex,benefitbirthday," +
            //         "benefitvocation,benefittelnocycode,benefittelnoareacode,benefittelno,benefitcountry,benefitaddressprovince,benefitaddresscity,benefitaddresscounty," +
            //         "benefitaddress,benefitemail,benefitpostcode,benefrelation,actualisself,actualctrlname,actualctrlcertype,actualctrlcerno,actualctrlvalidate,actualctrlsex,actualctrlbirthday,actualctrlvocation," +
            //         "actelnocycode,actelnoareacode,actualctrltelno,actualctrlcountry,actualctrladdrprovince,actualctrladdrcity,actualctrladdrcounty,actualctrladdr,actualctrlemail,actualctrlpostcode,actualrelation,tradingmethod"
            // );
            _obj.isdigniaryorceo = _this.acctInfo.specialpersonflag;
            _obj.livingcountry = _this.acctInfo.livingcountry;
            _obj.address = _this.acctInfo.livingaddress;
            _obj.nationality = _this.acctInfo.nationality;
            _obj.otherprovince = _this.acctInfo.province;
            _obj.location =
                _obj.nationality === "CN"
                    ? this.$cache.getDict("190021", _obj.livingaddressprovince)
                    : this.$cache.getDict("120109", _obj.nationality);
            _obj.belongregion = _obj.nationality === "CN" ? "中国" : "外国";
            if (!_this.isMobile) {
                _obj.mobileno = _this.acctInfo.mobileno;
            }
            _obj.tradepwd = this.$util.enc(_obj.pwd);
            // if (_obj.vocationcode === "06") {
            //     _obj.vocationsupple = _this.acctInfo.vocationsupple;
            // }
            let deliverway = _this.acctInfo.deliverway && _this.acctInfo.deliverway.join(",");
            _obj.deliverway = deliverway;
            if (this.acctInfo.validdate) {
                _obj.validtype = 0;
                if (
                    this.acctInfo.validdate == "99991231" ||
                    this.acctInfo.validdate == "长期有效"
                ) {
                    _obj.validtype = 1;
                }
            } else {
                _obj.validtype = 2;
            }
            if (this.acctInfo.actualctrlvalidate) {
                _obj.actualctrlvalitype = 0;
                if (
                    this.acctInfo.actualctrlvalidate == "99991231" ||
                    this.acctInfo.actualctrlvalidate == "长期有效"
                ) {
                    _obj.actualctrlvalitype = 1;
                }
            } else {
                _obj.actualctrlvalitype = 2;
            }
            const accRistRes = await userApi.acctRiskListManage({
                invtp: _this.acctInfo.invtp,
                opaction: "Q"
            });
            if (accRistRes.data.length > 0) {
                if (_this.fn) {
                    _this
                        .$alert("账号为风险客户，请联系客服进行修改操作!", "信息提示", {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: (action) => {
                                this.$router.push({
                                    name: "modifyinfo"
                                });
                            }
                        })
                        .then(() => {
                            return false;
                        })
                        .catch(() => {
                            return false;
                        });
                    return false;
                }
                _this.$message.warning("账号为风险客户，请联系客服进行修改操作!");
                return false;
            } else {
                const res = await userApi.updAcctInfo(_obj);
                if (res.data.appsheetserialno) {
                    _this.$cache.refreshUser(() => {
                        const message1 = "个人信息已更新成功，";
                        const message2 = _this.fn ? "" : "秒后回到个人信息页面";
                        const dataObj = {
                            type: "success",
                            message1: message1,
                            message2: message2,
                            onClose: function () {
                                if (_this.fn) {
                                    _this.$emit("fn-back", true);
                                } else {
                                    _this.$router.push({
                                        name: "info"
                                    });
                                }
                            }
                        };
                        if (!_this.fn) {
                            dataObj.number = 3;
                        }
                        _this.$handleAutoCloseMessage(dataObj);
                    });
                }
            }
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            const _this = this;
            // this.$util.highriskareaquery(this.acctInfo.nationality,this.acctInfo.province,res => {
            //     if(res == "1") {
            //         this.$alert("尊敬的客户您好，您的受益人所在的国籍为反洗钱法规确认的高危地区，请您联系客服修改！");
            //         return;
            //     }
            // })
            if (this.ocrUploadFlag === "5") {
                this.$alert("请先上传证件照");
                return;
            }
            if (
                (this.acctInfo.deliverway === "2" && this.acctInfo.faxcycode === "") ||
                (this.acctInfo.benefisself === "0" && this.acctInfo.benefittelnocycode === "") ||
                (this.acctInfo.actualisself === "0" && this.acctInfo.actelnocycode === "")
            ) {
                this.$alert("请选择国家码");
                return;
            }
            if (
                (this.acctInfo.deliverway === "2" &&
                    this.acctInfo.faxcycode === "86" &&
                    this.acctInfo.faxareacode === "") ||
                (this.acctInfo.benefittelnocycode === "86" &&
                    this.acctInfo.benefittelnoareacode === "") ||
                (this.acctInfo.actelnocycode === "86" && this.acctInfo.actelnoareacode === "")
            ) {
                this.$alert("请选择地区码！");
                return;
            }
            _this.setAddress();
            if (!this.checkAddressInfo() || !this.checkBenefActualInfo()) {
                return;
            }
            _this.$refs[formName].validate((valid, obj) => {
                if (valid) {
                    _this.dialogVisible = true;
                    _this.checked = false;
                } else {
                    this.$errorScroll(_this, obj);
                }
            });
        },
        // 再次校验证件号码
        checkCertNoAgain() {
            this.$refs.acctInfo.validateField("certNo");
        },
        // 检查存量客户性别、证件有效期、出生日期是否为空
        checkUser(validdate, info) {
            let _x = "";
            if (!this.$util.isEmpty(validdate)) {
                if (Number(format(new Date(), "YYYYMMDD")) > Number(validdate)) {
                    _x += "证件有效期已过期";
                }
            }
            if (this.$util.isEmpty(info.sex)) {
                if (!this.$util.isEmpty(_x)) {
                    _x += "，性别为空";
                } else {
                    _x += "性别为空";
                }
            }
            if (this.$util.isEmpty(validdate)) {
                if (_x != "") {
                    _x += "，证件有效期为空";
                } else {
                    _x += "证件有效期为空";
                }
            }
            if (this.$util.isEmpty(info.birthday)) {
                if (_x != "") {
                    _x += "，出生日期为空";
                } else {
                    _x += "出生日期为空";
                }
            }
            return _x;
        },
        getOcrOpenStatus() {
            const _this = this;
            const _x = this.$util.src("/acct/ocr/check", {}, true);
            const _data = {};
            this.$req({
                method: "GET",
                url: _x,
                timeout: 20000,
                data: _data
            })
                .then((res) => {
                    if (res.code === "0000000") {
                        if (res.record[0][0].isOpenOcr == "1") {
                            _this.ocrOnOff = true;
                            // ump开关(走ocr还是人工审核)
                            if (_this.acctInfo.certificatetype == "00" && _this.hasOcr == "1") {
                                _this.dateSet.dis = true;
                                _this.birthSet.dis = true;
                                const info = _this.$cache.getUser();
                                /* _this.dateSet.dis = true; */
                                let _val = "";
                                if (_this.$route.query) {
                                    _val = _this.$route.query.vailddate;
                                }
                                let validdate = _val || info.validdate;
                                let _x = _this.checkUser(validdate, info);
                                if (_x != "" && _this.$cache.getBinded()) {
                                    this.$alert(_x + ",请重新上传证件！", "信息提示", {
                                        confirmButtonText: "重新上传",
                                        callback: (action) => {
                                            _this.$router.push({
                                                name: "ocrinfoupd",
                                                query: {
                                                    certificatetype: _this.acctInfo.certificatetype
                                                }
                                            });
                                        }
                                    });
                                    return;
                                }
                            }
                            _this.ocrUploadFlag = res.record[0][0].ocrUploadFlag;
                            if (_this.ocrUploadFlag != "0" && _this.ocrUploadFlag != "5") {
                                _this.ocrStatus = true;
                                _this.ocrBtnInfo = "已上传";
                            }
                        }
                    } else {
                        _this.$message.error(res.msg);
                    }
                })
                .catch(() => {});
        },
        gotoUpdOcr() {
            const _this = this;
            this.$router.push({
                name: "ocrinfoupd",
                query: { certificatetype: _this.acctInfo.certificatetype }
            });
        },
        validateMin(rule, value, callback) {
            if (Number(value) < Number(format(new Date(), "YYYYMMDD"))) {
                callback(new Error("证件有效期必须大于当前日期，请重新选择"));
            } else {
                callback();
            }
        },
        specificnaturalper() {
            var _param = {
                invtp: "1",
                certificatetype: this.acctInfo.certificatetype,
                custfullname: this.acctInfo.custname,
                action: "Q"
            };
            this.$util.specificnaturalper(_param, (res) => {
                if (res != null) {
                    for (let i in this.isdigniaryorceo) {
                        if (
                            this.isdigniaryorceo[i].subitem == "0" ||
                            this.isdigniaryorceo[i].subitem == "A"
                        ) {
                            this.isdigniaryorceo.splice(i, 0);
                            i--;
                        }
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-user-info {
    padding-bottom: 30px;
    .acct-box {
        padding: 20px 10px;
        .el-form-item {
            margin-bottom: 18px;
            &.is-required .el-form-item__label:before {
                content: "";
            }
            &.required .el-form-item__label:before {
                content: "*";
                color: $color-c;
                margin-right: 2px;
            }
        }
        .btn-group {
            margin-top: 20px;
            text-align: center;
            .el-button + .el-button {
                margin-left: 30px;
            }
        }
        .el-select {
            width: 70%;
            .el-input {
                width: 100%;
            }
        }
        .el-input,
        .el-textarea {
            width: 70%;
            .el-input__inner {
                height: 38px;
                line-height: 36px;
            }
        }
        .vailddate-box {
            .el-select {
                width: 40%;
                .el-input {
                    width: 100%;
                }
            }
            .el-input,
            .el-textarea {
                width: 40%;
            }
            .comp-date-picker {
                width: 100%;
                .el-input {
                    width: 40%;
                }
            }
        }
        .el-form-item__label {
            padding: 0;
            line-height: 38px;
        }
    }
    .check-style {
        margin-right: 10px;
    }
}
</style>
